// src/pages/Users/Produits/components/ProductsHero.jsx

import React from "react";
import {
  FaExternalLinkAlt,
  FaGift,
  FaHeart,
  FaLaptopCode,
  FaRocket,
} from "react-icons/fa";

export default function ProductsHero({
  productsCount,
  demoLinksCount,
  donationUrl,
}) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-44 w-44 rounded-full bg-violet-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-48 w-48 rounded-full bg-sky-500/30 blur-3xl" />

      <div className="relative grid gap-5 lg:grid-cols-[1.1fr_0.9fr] lg:items-end">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-sky-200">
            MonAppliClub · Applications web
          </p>

          <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
            Des outils créés pour le terrain
          </h2>

          <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-200 sm:text-base">
            Je développe des applications web pour aider les clubs sportifs à
            gagner du temps : gestion, communication, inscriptions, documents,
            boutique, compétitions, assemblées générales et outils pédagogiques.
          </p>

          <div className="mt-5 flex flex-col gap-3 sm:flex-row">
            <a
              href="https://www.monappliclub.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-white px-5 text-sm font-bold text-slate-950 shadow-lg shadow-white/10 transition hover:-translate-y-0.5 hover:bg-slate-100 active:translate-y-0"
            >
              <FaRocket />
              Voir MonAppliClub
              <FaExternalLinkAlt className="text-xs opacity-70" />
            </a>

            <a
              href={donationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-pink-500 to-violet-500 px-5 text-sm font-bold text-white shadow-lg shadow-pink-500/20 transition hover:-translate-y-0.5 active:translate-y-0"
            >
              <FaHeart />
              Faire un don
            </a>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2">
          <HeroStat icon={FaLaptopCode} label="Applications" value={productsCount} />
          <HeroStat icon={FaExternalLinkAlt} label="Démos" value={demoLinksCount} />
          <HeroStat icon={FaGift} label="Don" value="5€" />
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-3 text-center backdrop-blur">
      <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-xl bg-white/15">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-lg font-bold leading-none">{value}</p>
      <p className="mt-1 text-[11px] font-medium text-slate-300">{label}</p>
    </div>
  );
}